import { RootState } from "../../../store";
import {DIRECTOR_ROLE_ID, DISPATCHER_ROLE_ID, DRIVER_ROLE_ID, IUser} from "../../../models/IUser";
import { createSelector } from "@reduxjs/toolkit";

const selectUsersState = (state: RootState) => state.users;

export const selectCurrentUser = createSelector([selectUsersState], (usersState) => usersState.current);

export const selectCurrentUserId = createSelector([selectUsersState], (usersState) => usersState.current?.id);

export const selectCurrentUserEmail = createSelector([selectUsersState], (usersState) => usersState.current?.email);

export const selectUsersFromOptions = createSelector([selectUsersState], (usersState) =>
  usersState.list.map((user) => ({ id: user.id, title: `${user.first_name} ${user.middle_name}` })),
);

export const selectIsUsersLoading = createSelector([selectUsersState], (usersState) => usersState.isLoading);

export const selectUserById = createSelector(
  [selectUsersState, (_: any, userId: string | number) => userId],
  (usersState, userId) => usersState.list.find((user: IUser) => user.id === userId),
);

export const selectAllUsers = createSelector(
    [selectUsersState],
    (usersState): IUser[] => {
      const FIRED_STATUS_ID = 4;

      const compareByName = (a: IUser, b: IUser) => {
        const byFirst = (a.first_name ?? "").localeCompare(b.first_name ?? "", "ru");
        if (byFirst !== 0) return byFirst;
        return (a.middle_name ?? "").localeCompare(b.middle_name ?? "", "ru");
      };

      const active: IUser[] = [];
      const fired: IUser[] = [];
      for (const user of usersState.list) {
        if (user.status_id === FIRED_STATUS_ID) fired.push(user);
        else active.push(user);
      }
      active.sort(compareByName);
      fired.sort(compareByName);

      return [...active, ...fired];
    },
);

export const getUserById = (state: RootState, useId: string): IUser => {
  return state.users.list.filter((user: IUser) => user.id === useId)[0];
};

export const getUserFullNameById = (state: RootState, userId: string): string => {
  return "asd";
};

export const selectIsDirector = createSelector(
    [selectCurrentUser],
    (currentUser) => currentUser?.role_id === DIRECTOR_ROLE_ID,
);

/** Текущий пользователь — водитель (кабинет водителя). */
export const selectIsDriver = createSelector(
    [selectCurrentUser],
    (currentUser) => currentUser?.role_id === DRIVER_ROLE_ID,
);

/** Доступ к управлению диспетчеризацией: руководитель или диспетчер. */
export const selectCanManageDispatch = createSelector(
    [selectCurrentUser],
    (currentUser) =>
        currentUser?.role_id === DIRECTOR_ROLE_ID ||
        currentUser?.role_id === DISPATCHER_ROLE_ID,
);

/**
 * Водители компании — для назначения на рейс (селект в форме рейса).
 * Уволенные отфильтрованы: назначать их на рейсы нельзя.
 */
export const selectDriverOptions = createSelector([selectAllUsers], (users) =>
    users
        .filter((u) => u.role_id === DRIVER_ROLE_ID && u.status_id !== 4)
        .map((u) => ({id: u.id, title: `${u.first_name} ${u.middle_name}`.trim()})),
);
